import { render, staticRenderFns } from "./PayPixOrderModal.vue?vue&type=template&id=d2a83f9a"
import script from "./PayPixOrderModal.vue?vue&type=script&lang=js"
export * from "./PayPixOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports